<div class="modal-header">
  <h5 class="modal-title">Satışı Cihazdan İptal Et</h5>
  <button type="button" class="btn-close" (click)="close()" [disabled]="sending"></button>
</div>

<!-- ══ 1) Onay ══ -->
<div class="modal-body" *ngIf="step === 'confirm'">
  <div class="text-center mb-3">
    <div class="fs-4 fw-bold">{{ sale.amount | number:'1.2-2' }} ₺</div>
    <div class="small text-muted">
      {{ sale.caseName }}
      <span *ngIf="sale.maskedPan" class="font-monospace ms-1">{{ sale.maskedPan }}</span>
    </div>
  </div>
  <p class="mb-2">Onaylı satış cihazdan iptal edilecek ve tutar karta iade edilecek.</p>
  <div class="alert alert-info py-2 small mb-0" *ngIf="isLinked">
    Bu ödeme bir satışa bağlı. İptal onaylanınca iade tutarı POS kasasından çıkar, gerçekleşmeyen komisyon
    kasaya gelir olarak geri girer ve müşteriye borç yazılır (müşteriye yansıtılan komisyon hariç).
    Satış kaydı yerinde kalır; ürün iade alınıyorsa satışı ayrıca silin.
  </div>
  <div class="alert alert-danger py-2 small mt-3 mb-0" *ngIf="error">{{ error }}</div>
</div>

<!-- ══ 2) Bekleme ══ -->
<div class="modal-body text-center py-4" *ngIf="step === 'waiting' && transaction">
  <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem"
       *ngIf="transaction.status !== Status.Suspended"></div>
  <i class="bx bx-pause-circle text-warning mb-3" style="font-size: 3.5rem" *ngIf="transaction.status === Status.Suspended"></i>
  <div class="fs-4 fw-bold">{{ transaction.amount | number:'1.2-2' }} ₺</div>
  <div class="mb-2">
    <span class="badge bg-{{ statusColor(transaction.status) }}">{{ statusLabel(transaction.status) }}</span>
  </div>
  <p class="mb-1">{{ waitingText }}</p>
  <p class="small text-muted mb-0" *ngIf="transaction.cancelRequestedAt">
    Geri çekme istendi; cihazın teyidi bekleniyor. İptal bu arada cihazda tamamlandıysa iade gerçekleşmiş olur.
  </p>
  <div class="alert alert-warning py-2 small mt-3 mb-0" *ngIf="pollError">
    {{ pollError }}
    <button class="btn btn-sm btn-link p-0 ms-1" (click)="checkNow()">Durumu sorgula</button>
  </div>
</div>

<!-- ══ 3) Sonuç ══ -->
<div class="modal-body text-center py-4" *ngIf="step === 'result' && transaction">
  <ng-container *ngIf="approved; else notApproved">
    <i class="bx bx-check-circle text-success" style="font-size: 3.5rem"></i>
    <h5 class="mt-2">Satış iptal edildi</h5>
    <p class="text-muted mb-0">
      {{ transaction.amount | number:'1.2-2' }} ₺ karta iade edildi.
      <ng-container *ngIf="isLinked">
        İade POS kasasından çıktı, komisyon kasaya gelir olarak geri yazıldı, müşteriye borç yazıldı.
      </ng-container>
    </p>
  </ng-container>
  <ng-template #notApproved>
    <i class="bx text-danger" style="font-size: 3.5rem"
       [ngClass]="transaction.status === Status.Cancelled ? 'bx-block' : 'bx-x-circle'"></i>
    <h5 class="mt-2">{{ transaction.status === Status.Cancelled ? 'İptal isteği geri çekildi' : 'İptal yapılamadı' }}</h5>
    <p class="text-muted mb-0">{{ transaction.errorMessage || statusLabel(transaction.status) }}</p>
  </ng-template>
</div>

<div class="modal-footer">
  <ng-container *ngIf="step === 'confirm'">
    <button class="btn btn-light" (click)="close()" [disabled]="sending">Vazgeç</button>
    <button class="btn btn-danger" (click)="send()" [disabled]="sending">
      <span class="spinner-border spinner-border-sm me-1" *ngIf="sending"></span>
      <i class="bx bx-undo me-1" *ngIf="!sending"></i>Cihazdan İptal Et
    </button>
  </ng-container>
  <ng-container *ngIf="step === 'waiting'">
    <button class="btn btn-light me-auto" (click)="close()"
            ngbTooltip="İşlem açık kalır; sonucu POS İşlemleri ekranında izlenir." container="body">
      Arka planda bırak
    </button>
    <button class="btn btn-outline-danger" (click)="cancelOnDevice()"
            [disabled]="cancelling || !!transaction?.cancelRequestedAt">
      <span class="spinner-border spinner-border-sm me-1" *ngIf="cancelling"></span>Cihazdan Geri Çek
    </button>
  </ng-container>
  <ng-container *ngIf="step === 'result'">
    <button class="btn btn-primary" (click)="close()">Tamam</button>
  </ng-container>
</div>
